import { useState } from "react";
import { Html5Qrcode } from "html5-qrcode";
import "./Home.css";
import { useNavigate } from "react-router-dom";

function Home() {
    const navigate = useNavigate();
    const [manualId, setManualId] = useState("");
    const [showScanner, setShowScanner] = useState(false);

    const handleSearch = () => {
        if (!manualId) return;
        navigate(`/id/${manualId.trim()}`);
    };

    const openScanner = () => {
        setShowScanner(true);

        setTimeout(() => {
            const scanner = new Html5Qrcode("reader");

            scanner.start(
                { facingMode: "environment" },
                {
                    fps: 10,
                    qrbox: 250
                },
                (decodedText) => {
                    console.log("Scanned:", decodedText);

                    scanner.stop().then(() => {
                        setShowScanner(false);
                        const id = decodedText.trim().split("id/")[1];
                        setManualId(id);

                    });
                },
                () => { }
            );
        }, 300);
    };

    return (
        <div className="home">

            {/* 🌟 HERO */}
            <section className="hero-section">

                <h1>
                    One Scan Can Save a Life
                </h1>

                <p>
                    Scan4Help connects people to emergency contacts instantly
                    during critical moments. No apps. No delays. Just help when it matters most.
                </p>

                <div className="hero-actions">

                    <button className="scan-btn" onClick={openScanner}>
                        📷 Scan QR Code
                    </button>

                    <div className="manual-input">
                        <input
                            placeholder="Enter ID manually"
                            value={manualId}
                            onChange={(e) => setManualId(e.target.value)}
                        />
                        <button onClick={handleSearch}>Go</button>
                    </div>

                </div>

            </section>

            {/* 💡 PURPOSE */}
            <section className="purpose-section">
                <h2>Why Scan4Help?</h2>

                <div className="purpose-grid">
                    <div className="purpose-card">
                        🚑 Instant Emergency Access
                        <p>No need to unlock phones or search contacts.</p>
                    </div>

                    <div className="purpose-card">
                        ⚡ Fast Response
                        <p>Reach the right people within seconds.</p>
                    </div>

                    <div className="purpose-card">
                        🔒 Secure & Private
                        <p>Your data is only used during emergencies.</p>
                    </div>
                </div>
            </section>

            {/* 🎥 VIDEO */}
            <section className="video-section">
                <h2>How It Works</h2>

                <div className="video-container">
                    <iframe
                        src="https://www.youtube.com/embed/YOUR_VIDEO_ID"
                        title="Scan4Help Demo"
                        allowFullScreen
                    ></iframe>
                </div>
            </section>

            {/* ❤️ TRUST */}
            <section className="trust-section">
                <p>Built with a simple mission —</p>
                <h3>Helping people reach help, faster.</h3>
            </section>

            {/* 🔥 SCANNER MODAL (NEW, DOESN’T BREAK UI) */}
            {showScanner && (
                <div className="scanner-overlay">
                    <div className="scanner-box">
                        <div id="reader"></div>

                        <button
                            className="close-btn"
                            onClick={() => setShowScanner(false)}
                        >
                            ✕ Close
                        </button>
                    </div>
                </div>
            )}

        </div>
    );
}

export default Home;